import * as React from 'react';
import { CheckboxChipButton, Responsive, TInputSize } from '@cian/ui-kit';

import { IconActionChevronDown16 } from '@cian/ui-kit-design-tokens/icons';

import { FiltersDropdownPopover } from './components/FiltersDropdownPopover';
import { FiltersModal } from './components/FiltersModal';
import * as styles from './DialogChipButton.css';
import { IDialogFilterItem } from '../../types/filterSelectors';
import { IJsonQuery } from '../../types/jsonQuery/jsonQuery';

interface IDialogChipButtonProps {
  checked: boolean;
  dialogFilters: IDialogFilterItem[];
  dialogTitle: string;
  label: string;
  onChange: (jsonQuery: IJsonQuery, isActive: boolean) => void;
  size: TInputSize;
  ['data-testid']?: string;
}

export const DialogChipButton: React.FC<IDialogChipButtonProps> = ({
  checked,
  dialogFilters,
  dialogTitle,
  label,
  onChange,
  ...rest
}) => {
  const buttonRef = React.useRef<HTMLLabelElement>(null);

  const [open, setOpen] = React.useState(false);

  const handleClose = React.useCallback(() => setOpen(false), []);

  const handleClick = React.useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    setOpen(open => !open);
    event.target.blur();
  }, []);

  const handleFilter = React.useCallback(
    (item: IDialogFilterItem) => {
      setOpen(false);
      onChange(item.jsonQuery, false);
    },
    [onChange],
  );

  const button = (
    <CheckboxChipButton
      ref={buttonRef}
      label={label}
      icon={
        <div className={styles['icon-wrapper']} data-testid="DialogChipButtonIcon">
          <IconActionChevronDown16 color="icon-main-default" />
        </div>
      }
      iconPosition="right"
      checked={checked}
      onChange={handleClick}
      {...rest}
    />
  );

  return (
    <>
      <Responsive desktop tablet>
        <FiltersDropdownPopover
          button={button}
          buttonRef={buttonRef}
          filters={dialogFilters}
          open={open}
          onClose={handleClose}
          onFilter={handleFilter}
        />
      </Responsive>
      <Responsive phone>
        <div className={styles['button-wrapper']}>{button}</div>
        <FiltersModal
          filters={dialogFilters}
          open={open}
          title={dialogTitle}
          onClose={handleClose}
          onFilter={handleFilter}
        />
      </Responsive>
    </>
  );
};
